










import { Component, Vue } from 'vue-property-decorator';
import BaseComponent from '../../../core/base.component';
import NavBar from '../NavBar/NavBar.layout.vue';
import JwtStorageService from '../../../services/shared/auth/jwt-storage.service';

@Component({
  name: 'MainLayout',
  components: {
    NavBar,
  },
})
export default class MainLayout extends BaseComponent {}
